function SearchIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.12"
        d="M15.3333 26.6667C21.5926 26.6667 26.6667 21.5926 26.6667 15.3333C26.6667 9.07411 21.5926 4 15.3333 4C9.07411 4 4 9.07411 4 15.3333C4 21.5926 9.07411 26.6667 15.3333 26.6667Z"
        fill="currentColor"
      />
      <path
        d="M28 28L23.3335 23.3333M26.6667 15.3333C26.6667 21.5926 21.5926 26.6667 15.3333 26.6667C9.07411 26.6667 4 21.5926 4 15.3333C4 9.07411 9.07411 4 15.3333 4C21.5926 4 26.6667 9.07411 26.6667 15.3333Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SearchIcon;
